
import { defineComponent, ref } from "vue";
import { hideModal } from "@/core/helpers/dom";
import Swal from "sweetalert2/dist/sweetalert2.js";
import Airtable from "airtable";

export default defineComponent({
  name: "merchant-airtable-modal",
  components: {},
  setup(props, context) {
    const formRef = ref<null | HTMLFormElement>(null);
    const airtableModalRef = ref<null | HTMLElement>(null);
    const loading = ref<boolean>(false);
    const formData = ref({
      apiKey: "keyFwSX22u1JHqp7I",
      base: "appZUqCkAbWrNnrXm",
      table: "Imported table",
    });

    const rules = ref({
      apiKey: [
        {
          required: true,
          message: "API key is required",
          trigger: "change",
        },
      ],
      base: [
        {
          required: true,
          message: "Base is required",
          trigger: "change",
        },
      ],
      table: [
        {
          required: true,
          message: "Table is required",
          trigger: "change",
        },
      ],
    });

    // eslint-disable-next-line
    const allRecords: any[] = [];

    const getData = () => {
      var base = new Airtable({ apiKey: formData.value.apiKey }).base(
        formData.value.base
      );

      base(formData.value.table)
        .select({
          sort: [{ field: "mid_number", direction: "asc" }],
        })
        .eachPage(
          function page(records, fetchNextPage) {
            records.forEach(function (record) {
              allRecords.push(record.fields);
            });

            fetchNextPage();
          },
          function done(err) {
            if (err) {
              let errorMsg = err.message
                ? err.message
                : "Something went wrong.";
              console.error(errorMsg);
              return;
            }

            // eslint-disable-next-line
            const originalData: any[] = [];
            if (allRecords.length > 0) {
              var firstRecordObj = allRecords[0];
              allRecords.forEach(function (record) {
                if (
                  Object.keys(firstRecordObj).length <
                  Object.keys(record).length
                ) {
                  firstRecordObj = record;
                }
              });

              var keys = Object.keys(firstRecordObj);
              originalData.push(keys);
              allRecords.forEach(function (record) {
                // eslint-disable-next-line
                const subData: any[] = [];
                keys.forEach((key) => {
                  subData.push(record[key]);
                });

                originalData.push(subData);
              });
            }

            context.emit("on-handle-completed", originalData);
            loading.value = false;
            hideModal(airtableModalRef.value);
          }
        );
    };

    const submit = () => {
      if (!formRef.value) {
        return;
      }

      formRef.value.validate((valid) => {
        if (valid) {
          loading.value = true;
          getData();
        } else {
          Swal.fire({
            text: "Sorry, looks like there are some errors detected, please try again.",
            icon: "error",
            buttonsStyling: false,
            confirmButtonText: "Ok, got it!",
            customClass: {
              confirmButton: "btn btn-primary",
            },
          });

          loading.value = false;
          return false;
        }
      });
    };

    return {
      formData,
      rules,
      submit,
      formRef,
      loading,
      airtableModalRef,
      getData,
      allRecords,
    };
  },
});
